import React, { createContext, useContext } from "react";
import { useNexaura } from "../hooks/useNexaura";

// Single shared instance of all Nexaura state + actions.
// Screens consume this — they do NOT each spin up their own data loader.
const NexauraContext = createContext(null);
export const useNexauraData = () => useContext(NexauraContext);

export function NexauraProvider({ children }) {
  const value = useNexaura();
  return <NexauraContext.Provider value={value}>{children}</NexauraContext.Provider>;
}
